import React, { useEffect, useRef, useState } from 'react'
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { constants } from '../../../../misc/constants';
import { BaseConfig } from '../../../BaseConfig';
import PopUp1 from '../../../general/pop-up1';
import { getGlobalTextSizeStyle, getSaveData, PageType, TextHtmlTagType } from '../../../../misc/tools';

import "./resume-game-window.css"
import { GameDataConfig } from '../../../../cvp-webgames-core/Misc/interfaces';
import { AnimationPage } from '../../../../cvp-webgames-core/UI/Animation/animation-page';
import { AnimationState } from '../../../../cvp-webgames-core/UI/Animation/animation-base';

class ResumeGameWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'start-scenarios',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/start-scenarios.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'return1',
				src: process.env.PUBLIC_URL + '/assets/images/return1.svg'
			}
		];
	}
}

export const resumeGameWindowCaching = new ResumeGameWindowCaching();

let gameData: GameDataConfig = null;

const ResumeGameWindow = (props: ResumeGameWindowConfig) => {
	if(!gameData) {
		gameData = getSaveData();
	}

	const allUnlockedScenarios = gameData.scenarios.filter((s) => !s.isLocked);
	const lastUnlockedScenario = allUnlockedScenarios[allUnlockedScenarios.length - 1];
	const lastUnlockedScenarioIndx = lastUnlockedScenario.scenarioWindow;
	const root = useRef(null);
	useEffect(() => {
		props.animation.updateProps({
			page: root.current
		});
	}, [root])
	return (
		<div ref={root} className={"modal-disable-select center-element resume-game-window-container " + props.animation.getInitialClass()} style={{
		}}>
			<PopUp1
				title= {constants.projectTitle}
				buttons={[
					{
						imgSrc: resumeGameWindowCaching.getItemByKey('start-scenarios').src,
						alt508: '',
						width: '80%',
						height: '80px',
						buttonText: "Start Scenarios",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: () => {props.onResumeScenarioClicked(lastUnlockedScenarioIndx);}
					},
					{
						imgSrc: resumeGameWindowCaching.getItemByKey('return1').src,
						alt508: '',
						width: '80%',
						height: '80px',
						buttonText: "Return to Previous Menu",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: props.onReturnToPreviousMenuClicked
					}
				]}
				onRenderContent={() => {
					return (
						<p className='default-text center-element-horizontal white-text' style={{
							textAlign:'center',
							width: '100%',
							...getGlobalTextSizeStyle(TextHtmlTagType.p)
						}}>
							<span className='title-text2 white-text'>Resume Game</span><br />
							<br />
							Please select an option:
						</p>);
				}}></PopUp1>
		</div>
	);

};

export interface ResumeGameWindowConfig extends BaseConfig {
	animation: AnimationPage;
	onReturnToPreviousMenuClicked: () => void;
	onResumeScenarioClicked: (page: PageType) => void;
	updateWindow: (windowToUse: PageType) => void;
}

export default ResumeGameWindow;